<template>
  <BrandForm />
</template>

<script>
import BrandForm from '@/layouts/components/form/BrandForm.vue'

export default {
  components: { BrandForm },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
